import Http from '../API'

const simcard_devices = {
  state: {
    group_simcard_devices: [],
    group_simcard_devices_tree: [],
    simcard_devices_list: {},
    simcard_devices_data: {},
    list_change_simcard_devices: false,
    simcard_devices_filter: {name: [] ,group: [], number:[], iccid: [], imsi:[], status: { online: true, blocked: false, crit_traffic: false }},
    simcard_devices_list_checked: {},
  },
  getters: {
    getSimcardDevicesGroups: (state) => {
      return state.group_simcard_devices
    },
    getSimcardDevicesGroupsTree: (state) => {
      return state.group_simcard_devices_tree
    },
    getSimcardDevicesGroupById: (state) => (id, parent) => {
      for (let i in state.group_simcard_devices) {
        if (+state.group_simcard_devices[i].id === +id) {
          return state.group_simcard_devices[i]
        }
      }
      if(!parent) {
        simcard_devices.mutations.groupSimcardDevicesUpdate(state, [...state.group_simcard_devices,  {'name': 'unknown', 'id': id, 'status': 'unknw', parent: -1 }])
      }
      return  state.group_simcard_devices[state.group_simcard_devices.length - 1]
    },
    getSimcardDevicesById: (state) => (id) => {
      if (state.simcard_devices_data[id] && state.simcard_devices_data[id].profile) {
        if (state.simcard_devices_data[id].profile.ts) {
          return state.simcard_devices_data[id]
        }
      } else {
        state.simcard_devices_data[id] = { profile: null, stats: { ts_start: -1, data: null }, load: true }
        return state.simcard_devices_data[id]
      }
    },
    getSimcardDevicesLink: (state) => (id) => {
      return !!state.simcard_devices_list[id];
    },
    getSimcardDevicesLinks: (state) => {
      return state.simcard_devices_list
    },
    getSimcardDevicesListChange: (state) => {
      return state.list_change_simcard_devices
    },
  },
  mutations: {

    groupSimcardDevicesUpdate (state, groups_simcard_devices) {
      state.group_simcard_devices = groups_simcard_devices
      let group = {}
      let id = 0
      for(let i in state.group_simcard_devices) {
        group[state.group_simcard_devices[i].id] = { ...state.group_simcard_devices[i], label: state.group_simcard_devices[i].name,  expanded: true }
      }

      for(let i in state.group_simcard_devices) {
        id = state.group_simcard_devices[i].id
        if(state.group_simcard_devices[i].parent !== -1) {

          if(group[state.group_simcard_devices[i].parent] === undefined ||  group[state.group_simcard_devices[i].parent].status === 'unknw') {
            group[id].parent = -1
          }
           else {
            if(group[state.group_simcard_devices[i].parent].children === undefined) {
              group[state.group_simcard_devices[i].parent].children = [];
            }
            group[state.group_simcard_devices[i].parent].children.push(group[id]);
          }
        }
      }

      let root_group  = []

      for(let i in group) {
        if(group[i].parent === -1 && group[i].status !== 'unknw') {
          root_group.push(group[i])
        }
      }

      state.group_simcard_devices_tree = root_group
    },

    setSimcardDevicesFilter (state, filter) {
      if (filter === null) {
        return false
      }
      state.simcard_devices_filter = filter
    },

    addLinkGroupSimcardDevices (state, id) {
      if (state.simcard_devices_list[id] === undefined ) {
         state.simcard_devices_list[id] = {}
      }
      state.simcard_devices_list = {...state.simcard_devices_list}
    },

    deleteLinkSimcardDevices(state, link) {
      if (state.simcard_devices_list[link.group] !== undefined && state.simcard_devices_list[link.group][link.id]) {

        for (let i in state.group_simcard_devices) {
          if (+state.group_simcard_devices[i].id === +link.group ) {
            if (+state.group_simcard_devices[i].parent !== -1 ) {
              state.simcard_list[state.group_simcard_devices[i].parent] = {}
            }
            break;
          }
        }

        delete state.simcard_devices_list[link.group][link.id]
      }
      state.simcard_devices_list = {...state.simcard_devices_list}
    },

    deleteLinkGroupSimcardDevices (state, params) {

      for( let id of params.ids ) {
        if (state.simcard_devices_list[id] !== undefined ) {
          delete state.simcard_devices_list[id]
        }
      }
      if(params.parent !== undefined && +params.parent !== -1) {
        state.simcard_devices_list[params.parent] = {}
      }

      state.simcard_devices_list = {...state.simcard_devices_list}
    },

    updateSimcardDevicesProfile (state, simcard_devices) {
      let oldSimcardDevices = state.simcard_devices_data[simcard_devices.imsi]
      if (oldSimcardDevices['profile'] === null) {
        let tmp = {...simcard_devices}
        delete tmp['ts']
        oldSimcardDevices['hash'] = JSON.stringify(tmp)
        oldSimcardDevices['profile'] = {...simcard_devices}
      } else {
        let tmp = {...simcard_devices}
        delete tmp['ts']
        if (oldSimcardDevices['hash'] !== JSON.stringify(tmp)) {
          for (let i in simcard_devices) {
            if (oldSimcardDevices['profile'][i] !== simcard_devices[i]) {
              oldSimcardDevices['profile'][i] = simcard_devices[i]
            }
          }
          oldSimcardDevices['hash'] = JSON.stringify(tmp)
        }
      }
      oldSimcardDevices['load'] = false
      state.simcard_devices_data = {...state.simcard_devices_data}

      let name = ''
      if (name.trim() === '') {
        name = (state.simcard_devices_data[simcard_devices.imsi].profile.custom_sim_name.trim() !== '') ? state.simcard_devices_data[simcard_devices.imsi].profile.custom_sim_name : state.simcard_devices_data[simcard_devices.imsi].profile.imsi
      }

      if(state.simcard_devices_list[simcard_devices.group_id] === undefined) {
        state.simcard_devices_list[simcard_devices.group_id] = {}
      }

      if (!state.simcard_devices_list[simcard_devices.group_id][simcard_devices.imsi] || state.simcard_devices_list[simcard_devices.group_id][simcard_devices.imsi].name !== name) {
        state.simcard_devices_list[simcard_devices.group_id][simcard_devices.imsi] = {
          name: name,
          icon: 'mdi-subdirectory-arrow-right',
          path: '/simcard_devices/' + state.simcard_devices_data[simcard_devices.imsi].profile.imsi
        }
        state.simcard_devices_list = {...state.simcard_devices_list}
      }

    },
    setNotExistSimcardDevices (state, id) {
      let oldSimcardDevices = state.simcard_devices_data[id]
      oldSimcardDevices.load = false
      state.simcard_devices_data = {...state.simcard_devices_data}
    },
    updateSimcardDevicesSection (state, simcard_devices) {
      if (state.simcard_devices_data[simcard_devices.id] === undefined) {
        state.simcard_devices_data[simcard_devices.id] = simcard_devices
      }
      state.simcard_devices_data[simcard_devices.id]['section'] = simcard_devices.section
    },
    updateSimcardDevicesStats (state, simcard_devices) {
      let oldSimcardDevices = state.simcard_devices_data[simcard_devices.id]
      oldSimcardDevices['stats'] = {...simcard_devices}
      state.simcard_devices_data = {...state.simcard_devices_data}
    },
    setSimcardDevicesListChange (state, status) {
      state.list_change_simcard_devices = status
    },

    clearSimcardDevices (state) {
      state.simcard_devices_list = {}
      state.simcard_devices_filter = {name: [] ,group: [], number:[], iccid: [], imsi:[], status: { online: true, blocked: false, crit_traffic: false }}
      state.simcard_devices_list_checked = {}
    },
  },

  actions: {

    deleteLinkSimcardDevices (context, id) {
      context.commit('deleteLinkSimcardDevices', id)
    },

    addLinkGroupSimcardDevices (context, id) {
      context.commit('addLinkGroupSimcardDevices', id)
    },
    deleteLinkGroupSimcardDevices (context, params) {
      context.commit('deleteLinkGroupSimcardDevices', params)
    },
    async groupSimcardDevicesUpdate () {
      await Http.v1.getSimcardsGroups((response) => {
        this.commit('groupSimcardDevicesUpdate', response.data)
        this.commit('deletePreloadName', 'groupSimcardDevicesUpdate')
      })
    },
    setSimcardDevicesFilter (context, filter) {
      context.commit('setSimcardDevicesFilter', filter)
    },
    updateSimcardDevicesProfile (_, id) {
      Http.v1.getSimcardProfile(id, (response) => {
        this.commit('updateSimcardDevicesProfile', { ts: Date.now() + 60000, ...response.data })
      }, () => { this.commit('setNotExistSimcardDevices',  id) })
    },
    updateSimcardDevicesSection (_, params) {
      this.commit('updateSimcardDevicesSection', { id: params.id, section: params.section })
    },
    updateSimcardDevicesStats (state, id, tsStart, tsEnd) {
      Http.v1.getSimcardStats(id, tsStart, tsEnd, (response) => {
        this.commit('updateSimcardDevicesStats', {id: id, ts_start: tsStart, ts_end: tsEnd, data: {...response.data}})
      })
      return false
    }
  }
}

export default simcard_devices
